const continuationForPart = (part, nextIndex) => {
  if (!part) return null;

  if (part.kind === 'Chapter') {
    return {
      nextIndex,
      autoStartPartId: part._id,
      waitingForSurveyId: null,
    };
  }

  if (part.kind === 'Survey') {
    return {
      nextIndex,
      autoStartPartId: null,
      waitingForSurveyId: part._id,
    };
  }

  return null;
};

export const continueAfterAudioEnded = (parts = [], currentIndex) => {
  const nextIndex = currentIndex + 1;
  return continuationForPart(parts[nextIndex], nextIndex);
};

export const continueAfterSurvey = (parts = [], currentIndex, continuation) => {
  const currentPart = parts[currentIndex];
  if (
    !currentPart ||
    currentPart.kind !== 'Survey' ||
    continuation?.waitingForSurveyId !== currentPart._id
  ) {
    return null;
  }

  const nextIndex = currentIndex + 1;
  return continuationForPart(parts[nextIndex], nextIndex);
};

export const continueFromNativeAudioEvent = (
  parts = [],
  currentIndex,
  event
) => {
  const partId = event?.data?.partId;
  if (!partId) return null;

  const nativePartIndex = parts.findIndex(
    part => String(part?._id) === String(partId)
  );
  if (nativePartIndex < 0) return null;

  if (event.type === 'AUDIO_ENDED') {
    const next = continueAfterAudioEnded(parts, nativePartIndex);
    // BRNative already owns the ready adjacent-chapter queue and starts the
    // next stream while the WebView may still be suspended. Move the visible
    // reader forward, but do not issue a duplicate AUDIO_LOAD from WebView.
    return next ? { ...next, autoStartPartId: null } : null;
  }

  if (
    (event.type === 'AUDIO_READY' || event.type === 'AUDIO_STATE') &&
    nativePartIndex !== currentIndex
  ) {
    return {
      nextIndex: nativePartIndex,
      autoStartPartId:
        event.type === 'AUDIO_READY' || event.data?.isPlaying ? partId : null,
      waitingForSurveyId: null,
    };
  }

  return null;
};

export const getNativeAudioContinuationQueue = (parts = [], currentIndex) => {
  const queue = [];
  for (let index = currentIndex + 1; index < parts.length; index += 1) {
    const part = parts[index];
    if (!part || part.kind !== 'Chapter') break;
    queue.push({ partId: part._id, title: part.title });
  }
  return queue;
};
